import { createSlice } from '@reduxjs/toolkit';

const initialInvoiceProduct = {
    product_name: '',
    product_unit: '',
    l15: '',
    kg: '',
    lit: '',
    gallon: '',
    note: '',
    price_unit: '',
    amount: '',
    product_id: '',
    price_id: '',
    price_no: '',
}
const initialState = {
    stage: 0,
    selectedCustomer: null,
    serial: null,
    startTime: '',
    endTime: '',
    valid_date: '',
    inventory: null,
    selectedSO: null,
    selectedTickets: [],
    note: '',
    saletype: null,
    loadingtype: null,
    so_data: undefined,
    priceData: '',
    searchFuelBatchTickets: null,
    invoice_products: [initialInvoiceProduct]
}
export const fuelBatchTicket = createSlice({
    name: 'create Fuel Batch Ticket',
    initialState,
    reducers: {
        setCreateFuelBatchTicketState: (state, action) => {
            state[action.payload.state] = action.payload.value
        },
        updateFuelInvoiceProducts: (state, action) => {       //update product,  nhan 3 tham so lan luot la index: index trong array, key: ten key cua object can update, value: gia tri moi cua key
            // state.invoice_products[action.payload.index][action.payload.key] = action.payload.value
            state.invoice_products = action.payload
        },
        resetFuelBatchTicket: () => ({...initialState})
    },
    
})

export const {setCreateFuelBatchTicketState, resetFuelBatchTicket, updateFuelInvoiceProducts} = fuelBatchTicket.actions
export default fuelBatchTicket.reducer